import React, { Children, useState } from 'react'
import 'keen-slider/keen-slider.min.css'
import { useKeenSlider } from 'keen-slider/react' // import from 'keen-slider/react.es' for to get an ES module
import { useTheme, css } from '@emotion/react'

function Carousel({
    children,
    rtl = true,
    loop = false,
    preview = { sm: 1, md: 2, lg: 4, xl: 6, xxl: 7 },
    controls = true,
    className
}) {
    const [currentSlide, setCurrentSlide] = React.useState(0)
    const [loaded, setLoaded] = useState(false)
    const [refCallback, instanceRef] = useKeenSlider(
        {
            slideChanged(slider) {
                setCurrentSlide(slider.track.details.rel)
            },
            created() {
                setLoaded(true)
            },
            rtl: rtl,
            loop: loop,
            breakpoints: {
                '(min-width: 640px)': {
                    slides: { perView: preview.md, spacing: 5 }
                },
                '(min-width: 1024px)': {
                    slides: { perView: preview.lg, spacing: 15 }
                },
                '(min-width: 1280px)': {
                    slides: { perView: preview.xl, spacing: 15 }
                },
                '(min-width: 1580px)': {
                    slides: { perView: preview.xxl, spacing: 15 }
                }
            },
            slides: {
                perView: preview.sm
            }
        },
        [
            // add plugins here
        ]
    )

    return (
        <>
            <div
                css={css`
                    position: relative;
                `}
                className={className}
            >
                <div ref={refCallback} className="keen-slider">
                    {Children.toArray(children)}
                </div>
                {controls && loaded && instanceRef.current && (
                    <>
                        <Arrow
                            left
                            onClick={(e) =>
                                e.stopPropagation() ||
                                instanceRef.current?.next()
                            }
                            disabled={currentSlide === 0}
                            style="left:-10px; top:0; margin:auto; height:100%; cursor:pointer; position:absolute;"
                        />

                        <Arrow
                            onClick={(e) =>
                                e.stopPropagation() ||
                                instanceRef.current?.prev()
                            }
                            disabled={
                                currentSlide ===
                                instanceRef.current.track.details?.slides
                                    .length -
                                    1
                            }
                            style="right:-10px; top:0; margin:auto; height:100%; cursor:pointer; position:absolute;"
                        />
                    </>
                )}
            </div>
            {/* {controls && loaded && instanceRef.current && (
                <div className="dots">
                    {[
                        ...Array(
                            instanceRef.current.track.details.slides.length
                        ).keys()
                    ].map((idx) => {
                        return (
                            <button
                                key={idx}
                                onClick={() => {
                                    instanceRef.current?.moveToIdx(idx)
                                }}
                                className={
                                    'dot' +
                                    (currentSlide === idx ? ' active' : '')
                                }
                            ></button>
                        )
                    })}
                </div>
            )} */}
        </>
    )
}

function Arrow(props) {
    const disabeld = props.disabled ? ' arrow--disabled' : ''
    const theme = useTheme()
    return (
        <svg
            onClick={props.onClick}
            className={`arrow w-6 ${props.className} ${
                props.left ? 'arrow--left' : 'arrow--right'
            } ${disabeld}`}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill={theme.colors.lightGray}
            css={css`
                ${props.style}
            `}
        >
            {props.left && (
                <path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z" />
            )}
            {!props.left && (
                <path d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z" />
            )}
        </svg>
    )
}

export default Carousel
